import axios from "axios";
import $day from "dayjs"
const module = {
  namespaced: true,
  state: {
    children: {
      user_children: {}
    },
  },
  mutations: {
    setChildren: (state, info) => {
      info.user_data.user_children.map((item) => {
        item.editableFlag = true
        return item
      })
      state.children = info.user_data
    },
    addChild: (state, info) => {
      info.user_children.editableFlag = true
      state.children.user_children.push(info.user_children)
    },
    updateChild: (state, info) => {
      return state.data.user_children = state.data.user_children.map((item) => {
        if (item.id == info.user_children.id) {
          item = info
        }
        return item
      })
    },
    removeChild: (state, info) => {
      return state.children.user_children = state.children.user_children.map((item) => {
        return item.id != info
      })
    },
  },
  actions: {
    async fetchChildren ({commit, rootState}) {
      const response = await axios.get('admin/users/data/'+rootState.user.currentUser)
      commit ('setChildren', response.data)
    },
    async updateChild ({commit}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      delete data['user_id']
      const response = await axios.put('admin/user/data/children/'+data.id, data)
      commit ('updateInfo', response.data)
    },
    async addUserChild ({commit, rootState}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      data.user_id = rootState.user.currentUser
      const response = await axios.post('admin/user/data/children', data)
      commit ('addChild', response.data)
    },
    async removeChild ({commit}, id) {
      await axios.delete('admin/user/data/children/'+id).then(() => {
        commit ('removeChild', id)
      })
    },
  }
}
export default module
